import { useState } from 'react'
import IconClose from '../../../assets/icons/icon-close.svg?react'
import IconButton from '@/components/ui/IconButton/IconButton'
import Modal from '../Modal/Modal.tsx'
import WorkspaceSettingsModalGeneral from './components/WorkspaceSettingsModalGeneral/WorkspaceSettingsModalGeneral.tsx'
import WorkspaceSettingsModalMembers from './components/WorkspaceSettingsModalMembers/WorkspaceSettingsModalMembers.tsx'
import WorkspaceSettingsModalWorkflow from './components/WorkspaceSettingsModalWorkflow/WorkspaceSettingsModalWorkflow.tsx'
import WorkspaceSettingsModalLabels from './components/WorkspaceSettingsModalLabels/WorkspaceSettingsModalLabels.tsx'
import WorkspaceSettingsModalBilling from './components/WorkspaceSettingsModalBilling/WorkspaceSettingsModalBilling.tsx'
import WorkspaceSettingsModalApi from './components/WorkspaceSettingsModalApi/WorkspaceSettingsModalApi.tsx'
import WorkspaceSettingsModalIntegrations from './components/WorkspaceSettingsModalIntegrations/WorkspaceSettingsModalIntegrations.tsx'
import WorkspaceSettingsModalUsage from './components/WorkspaceSettingsModalUsage/WorkspaceSettingsModalUsage.tsx'
import WorkspaceSettingsNavigation from './components/WorkspaceSettingsNavigation/WorkspaceSettingsNavigation.tsx'
import css from './WorkspaceSettingsModal.module.css'

export type TabType = 'general' | 'workflow' | 'labels' | 'members' | 'billing' | 'apps' | 'api' | 'export' | 'integrations' | 'usage'

export const NAV_OPTIONS: { label: string; tab: TabType }[] = [
    { label: 'General', tab: 'general' },
    { label: 'Statuses', tab: 'workflow' },
    { label: 'Labels', tab: 'labels' },
    { label: 'Members', tab: 'members' },
    { label: 'Billing & Plans', tab: 'billing' },
    { label: 'Usage', tab: 'usage' },
    { label: 'Integrations', tab: 'integrations' },
    { label: 'API', tab: 'api' },
]

interface WorkspaceSettingsModalProps {
    onClose: () => void
    initialTab?: TabType
}

const WorkspaceSettingsModal = ({ onClose, initialTab = 'general' }: WorkspaceSettingsModalProps) => {
    const [activeTab, setActiveTab] = useState<TabType>(initialTab)

    const renderContent = () => {
        switch (activeTab) {
            case 'general':
                return <WorkspaceSettingsModalGeneral />
            case 'members':
                return <WorkspaceSettingsModalMembers />
            case 'workflow':
                return <WorkspaceSettingsModalWorkflow />
            case 'labels':
                return <WorkspaceSettingsModalLabels />
            case 'billing':
                return <WorkspaceSettingsModalBilling />
            case 'api':
                return <WorkspaceSettingsModalApi />
            case 'integrations':
                return <WorkspaceSettingsModalIntegrations />
            case 'usage':
                return <WorkspaceSettingsModalUsage />
            default:
                return null
        }
    }

    return (
        <Modal onClose={onClose} maxWidth={728} mobileFullScreen>
            <div className={css.buttons}>
                <IconButton icon={<IconClose />} onClick={onClose} />
            </div>
            <div className={css.container}>
                <div className={css.navigation}>
                    <WorkspaceSettingsNavigation options={NAV_OPTIONS} activeTab={activeTab} onTabChange={setActiveTab} />
                </div>
                <div className={css.content}>
                    {renderContent()}
                </div>
            </div>
        </Modal>
    )
}

export default WorkspaceSettingsModal
